<div class="w-100 h-100 d-flex justify-content-center align-items-center">
  <div class="loading-wrap" style="width: 130px; height: 130px;">
    <img src="./assets/images/advofin_loading.svg" alt="loading">
<!--    <img src="./assets/images/advofin_loading_finished_animation.svg?v={{svgId}}" alt="loading" *ngIf="spinnerCheckmark">-->
  </div>
</div>
